'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by Administrator on 2016/9/26.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reduxForm = require('redux-form');

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _GoeasyRadio = require('../GoeasyInputField/GoeasyRadio');

var _GoeasyRadio2 = _interopRequireDefault(_GoeasyRadio);

var _GoeasySelectField = require('../GoeasyInputField/GoeasySelectField');

var _GoeasySelectField2 = _interopRequireDefault(_GoeasySelectField);

var _reactRadio = require('react-radio');

var _reactRadio2 = _interopRequireDefault(_reactRadio);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _ErrorLabel = require('../ErrorLabel/ErrorLabel');

var _ErrorLabel2 = _interopRequireDefault(_ErrorLabel);

var _AddressChosenComponentThreeLevel = require('../AddressChosenComponent/AddressChosenComponentThreeLevel');

var _AddressChosenComponentThreeLevel2 = _interopRequireDefault(_AddressChosenComponentThreeLevel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangeInfoModal = (_dec = (0, _reduxForm.reduxForm)({
  form: 'personalInfoChange',
  fields: ['nickName', 'name', 'email', 'mobile', 'gender', 'city', 'wechatId', 'idNumber', 'education']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ChangeInfoModal, _Component);

  function ChangeInfoModal() {
    (0, _classCallCheck3.default)(this, ChangeInfoModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ChangeInfoModal).call(this));

    _this.state = {
      closeHover: false
    };
    return _this;
  }

  (0, _createClass3.default)(ChangeInfoModal, [{
    key: 'onGenderChange',
    value: function onGenderChange(value) {
      var gender = this.props.fields.gender;

      gender.onChange(value);
    }
  }, {
    key: 'onModalHide',
    value: function onModalHide() {
      var onClose = this.props.onClose;

      if (onClose) {
        onClose();
      }
    }
  }, {
    key: 'onEducationChange',
    value: function onEducationChange(val) {
      var education = this.props.fields.education;

      education.onChange(val);
    }

    /*
     onBirthDayChange(event) {
     const {fields: {birthday}} = this.props;
     console.log('123');
     if (birthday) {
     let birthdayVal = '';
     if (event.target.value instanceof Date) {
     birthdayVal = event.target.value.getYear() + '/' + (event.target.value.getMonth() + 1) + event.target.value.getDay();
     }
     birthday.onChange(birthdayVal);
     }
     }*/

  }, {
    key: 'addressChange',
    value: function addressChange(value, level) {
      var onAddressChange = this.props.onAddressChange;

      if (onAddressChange) {
        onAddressChange(value, level);
      }
    }
  }, {
    key: 'closeImgMouseOver',
    value: function closeImgMouseOver() {
      this.setState({
        closeHover: true
      });
    }
  }, {
    key: 'closeImgMouseLeave',
    value: function closeImgMouseLeave() {
      this.setState({
        closeHover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ChangeInfoModal.scss');
      var _props = this.props;
      var _props$fields = _props.fields;
      var nickName = _props$fields.nickName;
      var name = _props$fields.name;
      var email = _props$fields.email;
      var mobile = _props$fields.mobile;
      var gender = _props$fields.gender;
      var idNumber = _props$fields.idNumber;
      var city = _props$fields.city;
      var wechatId = _props$fields.wechatId;
      var education = _props$fields.education;
      var handleSubmit = _props.handleSubmit;
      var labelStyle = _props.labelStyle;
      var isOpened = _props.isOpened;
      var info = _props.info;
      var addressData = _props.addressData;
      var submitError = _props.submitError;
      var changing = _props.changing;

      var inputLabelStyle = {};
      if (labelStyle) {
        inputLabelStyle = (0, _extends3.default)({}, labelStyle);
      }
      var customStyle = {
        content: {
          background: '#ffffff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 9,
          border: '0',
          borderRadius: '30px',
          boxShadow: '3px 2px 20px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          paddingLeft: '0px',
          paddingRight: '0px',
          paddingTop: '2rem',
          // position: 'fixed',
          position: 'absolute',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: '600px',
          maxWidth: '60rem'
        }
      };
      var educationOptions = [];
      if (info.educationList instanceof Array) {
        educationOptions = info.educationList.map(function (educationInfo, index) {
          return _react2.default.createElement(
            'option',
            { key: index, value: educationInfo.value },
            educationInfo.label || educationInfo.value
          );
        });
      }
      educationOptions.splice(0, 0, _react2.default.createElement(
        'option',
        { key: 'null', value: '' },
        ' -- 请选择 -- '
      ));
      /*
       let birthdayVal;
       if (birthday && birthday.value && typeof birthday === 'string') {
       birthdayVal = new Date(birthday.value);
       }*/
      var closeHover = this.state.closeHover;

      var hoverClassName = styles.zhuan_a;
      if (closeHover) {
        hoverClassName = styles.zhuan;
      }
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'form',
          { className: styles.component },
          _react2.default.createElement(
            'div',
            { className: styles.modalTitle },
            _react2.default.createElement('img', { className: hoverClassName, onMouseOver: this.closeImgMouseOver.bind(this),
              onMouseLeave: this.closeImgMouseLeave.bind(this), onClick: this.onModalHide.bind(this),
              src: 'http://tupian.goeasy.cn:9999/yipinwang/third/close.png' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalContent },
            _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, label: '昵称：', inputPlaceholder: '', formProps: nickName }),
            _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, label: '真实姓名：', inputPlaceholder: '', formProps: name }),
            _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, label: '用户邮箱：', inputPlaceholder: '', formProps: email }),
            _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, label: '联系电话：', inputPlaceholder: '', formProps: mobile }),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '20px' } },
              _react2.default.createElement(
                'label',
                { className: styles.label },
                '性别：'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.input },
                _react2.default.createElement(
                  _reactRadio2.default,
                  { name: 'gender', value: gender.value,
                    onChange: this.onGenderChange.bind(this) },
                  _react2.default.createElement(_GoeasyRadio2.default, { Id: 'gender_male', currentData: { value: '男', label: '男' },
                    customStyle: { float: 'left', marginLeft: '10px' },
                    fieldsType: gender }),
                  _react2.default.createElement(_GoeasyRadio2.default, { Id: 'address_female', currentData: { value: '女', label: '女' },
                    customStyle: { float: 'left', marginLeft: '10px' },
                    fieldsType: gender })
                )
              ),
              _react2.default.createElement('div', { className: 'clear' })
            ),
            _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, label: '身份证号：', inputPlaceholder: '',
              formProps: idNumber }),
            _react2.default.createElement(_GoeasyInputField2.default, { labelStyle: inputLabelStyle, label: '微信号：', inputPlaceholder: '',
              formProps: wechatId }),
            _react2.default.createElement(
              _GoeasySelectField2.default,
              { labelStyle: inputLabelStyle, label: '教育程度：', inputPlaceholder: '',
                onChange: this.onEducationChange.bind(this),
                formProps: education },
              educationOptions
            ),
            _react2.default.createElement(_AddressChosenComponentThreeLevel2.default, { label: '所在城市：', labelStyle: { color: '#000' }, formProps: city,
              onAddressChange: this.addressChange.bind(this),
              data: addressData })
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          submitError ? _react2.default.createElement(_ErrorLabel2.default, { error: submitError }) : '',
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(_SubmitBtn2.default, { style: { display: changing ? 'none' : 'block' }, btnClick: handleSubmit, text: '提交' }),
          _react2.default.createElement(_SubmitBtn2.default, { style: { display: changing ? 'none' : 'block' }, btnClick: this.onModalHide.bind(this), text: '关闭' })
        )
      );
    }
  }]);
  return ChangeInfoModal;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,

  labelStyle: _react.PropTypes.object,
  addressData: _react.PropTypes.object,
  isOpened: _react.PropTypes.bool,
  onClose: _react.PropTypes.func,
  info: _react.PropTypes.object,
  onAddressChange: _react.PropTypes.func,
  changing: _react.PropTypes.bool,
  submitError: _react.PropTypes.string
}, _temp)) || _class);
exports.default = ChangeInfoModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ChangeInfoModal/ChangeInfoModal.js
 ** module id = 1319
 ** module chunks = 0
 **/